@if (header) {
<h3 [id]="headerId">{{ header }}</h3>
} @if (label) {
<h4 [id]="labelId">
    <span [innerHTML]="label"></span>
    @if (showRequiredIndicator) {
    <span class="required"> *</span>
    }
</h4>
}
<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
    <div fxFlex="100" fxLayoutAlign="start center" fxFlex.xs="100" fxFlexFill>
        <span class="radio-checkbox-group" fxFlex="100">
            <mat-radio-group
                [value]="value"
                color="primary"
                (change)="updateRadioGroup($event)"
                [attr.aria-labelledby]="activeHeadingId"
            >
                <ul role="presentation">
                    @for (selection of selections; track selection) {
                    <li>
                        <mat-radio-button [value]="selection.selectionId">
                            <span class="wrap-mat-radio-checkbox-label">
                                {{ selection.label }}
                            </span>
                        </mat-radio-button>
                    </li>
                    }
                </ul>
            </mat-radio-group>
            @if (formSubmitted && hasRequiredError) {
            <mat-error>
                {{ requiredMessage }}
            </mat-error>
            }
        </span>
    </div>
</div>
